'use client'

import { motion } from 'framer-motion'
import { GeometricBackground } from '@/components/ui/geometric-background'
import { MarketingNavbar } from '@/components/layout/marketing-navbar'
import { MarketingFooter } from '@/components/layout/marketing-footer'
import Link from 'next/link'
import { Home, ChevronRight } from 'lucide-react'

export default function LegalLayout({
    children,
}: {
    children: React.ReactNode
}) {
    return (
        <div className="relative min-h-screen bg-black text-white selection:bg-primary/30">
            <GeometricBackground />

            <MarketingNavbar />

            <main className="relative z-10 pt-32 pb-24 px-6">
                <div className="max-w-3xl mx-auto">
                    {/* Breadcrumbs */}
                    <div className="flex items-center gap-2 text-xs font-mono text-white/20 uppercase tracking-widest mb-8">
                        <Link href="/" className="hover:text-primary transition-colors">Home</Link>
                        <ChevronRight className="w-3 h-3" />
                        <span className="text-white/40">Legal</span>
                    </div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        {children}
                    </motion.div>
                </div>
            </main>

            <MarketingFooter />
        </div>
    )
}
